// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section « Préparation du Bon de Commande » : recap read-only en grille responsive (label gris +
   valeur). Geometrie calquee sur \`.opms__recap-*\` du MS (SuiviOperationMSV2.css), en classes
   prefixees BC : copie ISOLEE, aucun partage cross-module — meme convention que le reste des vues BC
   (cf. l'en-tete de OperationNotification.css). Palette fermee. */

.bc-recap-grid {
  display: grid;
  /* \`auto-fit\` + \`minmax\` : le nombre de colonnes suit la largeur disponible, sans point de rupture
     a maintenir. Meme valeur que le MS pour que les deux recaps se lisent pareil. */
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.2rem 2rem;
}

.bc-recap-field {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.bc-recap-label {
  font-size: 1.2rem;
  color: #6b7280;
}

.bc-recap-value {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
  /* Un SIRET ou un nom de titulaire long ne doit pas elargir sa colonne et casser la grille. */
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBCV2/components/OperationPreparationBC.css"],"names":[],"mappings":"AAAA;;;kEAGkE;;AAElE;EACE,aAAa;EACb;oFACkF;EAClF,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6FAA6F;EAC7F,sBAAsB;AACxB","sourcesContent":["/* Section « Préparation du Bon de Commande » : recap read-only en grille responsive (label gris +\n   valeur). Geometrie calquee sur `.opms__recap-*` du MS (SuiviOperationMSV2.css), en classes\n   prefixees BC : copie ISOLEE, aucun partage cross-module — meme convention que le reste des vues BC\n   (cf. l'en-tete de OperationNotification.css). Palette fermee. */\n\n.bc-recap-grid {\n  display: grid;\n  /* `auto-fit` + `minmax` : le nombre de colonnes suit la largeur disponible, sans point de rupture\n     a maintenir. Meme valeur que le MS pour que les deux recaps se lisent pareil. */\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.2rem 2rem;\n}\n\n.bc-recap-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.bc-recap-label {\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n.bc-recap-value {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #2c3948;\n  /* Un SIRET ou un nom de titulaire long ne doit pas elargir sa colonne et casser la grille. */\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
